import type { SubstitutionConfig } from '../types';
import type { ProjectAccessRow } from './projectAccess';
import { getActiveSubstitutionFor } from './substitutionService';

/**
 * Vertretungsangabe der Projektkarte: Vertritt der angemeldete Nutzer dieses
 * Projekt HEUTE, liefert die Funktion SEINEN Vertretungseintrag (Zeitraum fuer
 * die Karte), sonst null.
 *
 * Keine eigene Regel, sondern dieselbe wie Dashboard-Banner
 * (dashboardModel.selectRelevantProjects / substitutionProgress) und
 * Projektliste (projectAccess.getProjectRelation → isSubstitute): aktiver
 * Eintrag aus `substitutions[]` samt Alt-Feld, Start UND Ende geprueft,
 * Vertreter per E-Mail. Der Listenauszug traegt die vollen Metadaten, die
 * Eintraege sind also da.
 *
 * Bewusst der EIGENE Eintrag und nicht der erste aktive
 * (`getActiveSubstitution`): Bei zwei gleichzeitigen Vertretern zeigte die
 * Karte sonst den Zeitraum des Kollegen — und eine Vertretung, die jemand
 * anderes uebernimmt, macht die Karte nicht zur eigenen Vertretung.
 */
export const cardSubstitution = (
    project: ProjectAccessRow | null | undefined,
    userEmail: string | null | undefined,
    date: Date = new Date(),
): SubstitutionConfig | null =>
    getActiveSubstitutionFor(project?.data?.metadata, userEmail, date);
